// extracted by mini-css-extract-plugin
export var notificationHost = "_mh-0";